import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Faceboockconnect } from '../Component/Integration Component/Faceboockconnect';

export const FacebookIntegrationpage = () => {
  return (
    <Container className="startpage">
      <Link to={`/`} style={{ textDecoration: 'none', color: '#0F7687' }}>
        <span style={{ fontWeight: 'bold' }}>Home</span>
      </Link>{' '}
      <KeyboardDoubleArrowRightIcon /> <span>Facebook Integration</span>
      {/* button connect with meta*/}
      <Faceboockconnect />
    </Container>
  );
};
